import BreadcrumbView from "../../angularjs/common/breadcrumb/breadcrumb.html";

angular.module("common-routes", [])

    .config(['$stateProvider', function ($stateProvider) {

        $stateProvider
            .state('common', {
                url: "/common",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView
            })
            // Languages
            .state('common.languages', {
                url: "/languages",
                abstract: true,
                template: '<div ui-view=""></div>'
            })
            .state('common.languages.list', {
                url: "/list",
                template: '<languages-list-page />',
                controller: ['$filter', '$rootScope', 'logService', '$state', function ($filter: any, $rootScope: any, logService: any, $state: any) {

                    $rootScope.title = $filter('translate')('languages.management.title');
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('languages.management.title') },
                    ];

                }],
                cache: false,
                data: { pageTitle: 'Idiomas' },
                requiredPermission: ["LANGUAGES_READ"]
            })
            .state('common.languages.edit', {
                url: "/edit/:id",
                template: '<languages-edit-page />',
                controller: ['$filter', '$rootScope', 'logService', '$stateParams', '$state', function ($filter: any, $rootScope: any, logService: any, $stateParams: any, $state: any) {

                    $rootScope.title = $filter('translate')('languages.management.title');

                    if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                        $rootScope.breadcrumb = [
                            { title: $filter('translate')('languages.management.title'), url: `languages.management` },
                            { title: $filter('translate')('languages.management.title_add') },
                        ];

                    } else {

                        $rootScope.breadcrumb = [
                            { title: $filter('translate')('languages.management.title'), url: `languages.management` },
                            { title: $filter('translate')('languages.management.title_edit') },
                        ];

                    }

                }],
                cache: false,
                data: { pageTitle: 'Idiomas' },
                requiredPermission: ["LANGUAGES_READ"]
            })
            // identificationtypes
            .state('common.identificationtypes', {
                url: "/identificationtypes",
                abstract: true,
                template: '<div ui-view=""></div>'
            })
            .state('common.identificationtypes.list', {
                url: "/list",
                template: '<identification-types-list-page />',
                controller: ['$filter', '$rootScope', 'logService', '$state', function ($filter: any, $rootScope: any, logService: any, $state: any) {

                    $rootScope.title = $filter('translate')('identification_types.title');
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('identification_types.title') },
                    ];

                }],
                cache: false,
                data: { pageTitle: 'Tipos de identificaci�n' },
               // requiredPermission: ["RESOURCE_READ"]
            })
            .state('common.identificationtypes.edit', {
                url: "/edit/:id",
                template: '<identification-types-edit-page />',
                controller: ['$filter', '$rootScope', 'logService', '$state', '$stateParams', function ($filter: any, $rootScope: any, logService: any, $state: any, $stateParams: any) {

                    $rootScope.title = $filter('translate')('identification_types.title');
                    if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                        $rootScope.breadcrumb = [
                            { title: $filter('translate')('identification_types.title'), url: `identification_types.list` },
                            { title: $filter('translate')('identification_types.title_add') },
                        ];

                    } else {
                        $rootScope.breadcrumb = [
                            { title: $filter('translate')('identification_types.title'), url: `identification_types.list` },
                            { title: $filter('translate')('identification_types.title_edit') },
                        ];

                    }

                }],
                cache: false,
                data: { pageTitle: 'Tipos de identificaci�n' },
                // requiredPermission: ["RESOURCE_READ"]
            })
    }]);
